var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.376 5.364 0 11.988 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 11.988 24C5.364 24 0 18.624 0 12ZM7.8 7.20007C6.80589 7.20007 6 8.00596 6 9.00007C6 9.99419 6.80589 10.8001 7.8 10.8001C8.79411 10.8001 9.6 9.99419 9.6 9.00007C9.6 8.00596 8.79411 7.20007 7.8 7.20007ZM16.2 7.20007C15.2059 7.20007 14.4 8.00596 14.4 9.00007C14.4 9.99419 15.2059 10.8001 16.2 10.8001C17.1941 10.8001 18 9.99419 18 9.00007C18 8.00596 17.1941 7.20007 16.2 7.20007ZM12 21.6C6.69602 21.6 2.40002 17.304 2.40002 12C2.40002 6.69596 6.69602 2.39996 12 2.39996C17.304 2.39996 21.6 6.69596 21.6 12C21.6 17.304 17.304 21.6 12 21.6ZM7.31434 17.3101C8.34106 15.4941 10.0825 14.4 11.995 14.4C13.9075 14.4 15.6489 15.4828 16.6857 17.3101C16.9071 17.7048 16.7964 18.2237 16.4441 18.4718C16.3132 18.5508 16.1824 18.5959 16.0415 18.5959C15.7898 18.5959 15.5382 18.4606 15.3972 18.2011C14.6524 16.8702 13.3841 16.0806 11.995 16.0806C10.6059 16.0806 9.33759 16.8702 8.59271 18.2011C8.37126 18.5959 7.90823 18.72 7.55593 18.4718C7.20362 18.2237 7.0929 17.7048 7.31434 17.3101Z",
    fill: "#E1604D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriste);
export default __webpack_public_path__ + "static/media/Triste.611e7167acd9db8b82ffa951d8362676.svg";
export { ForwardRef as ReactComponent };